const React = require("react");
const T = require("prop-types");
const Paper = require("material-ui/Paper").default;
const TextField = require("material-ui/TextField").default;
const RaisedButton = require("material-ui/RaisedButton").default;
const moment = require("moment");
const Deeply = require("utils/deeply");

const internals = {};

internals.paperStyle = {
    padding: "3rem",
    margin: "2rem 0"
};

module.exports = class PromoCodeForm extends React.Component {
    static propTypes = {
        isSaving: T.bool.isRequired,
        promo: T.object,
        showDelete: T.bool,

        delete: T.func,
        save: T.func.isRequired
    };

    constructor(props, context) {
        super(props, context);

        if (this.props.promo) {
            this.state = {
                promo: {
                    id: props.promo.id || null,
                    code: props.promo.code || "",
                    description: props.promo.description || "",
                    discount: props.promo.discount || 0,
                    startDate: props.promo.startDate,
                    endDate: props.promo.endDate
                }
            };
        } else {
            this.state = {
                promo: {
                    code: "",
                    description: "",
                    discount: 0,
                    startDate: null,
                    endDate: null
                }
            };
        }

        this.state.formError = "";

        this.delete = this.delete.bind(this);
        this.onSave = this.onSave.bind(this);
        this.saveForm = this.saveForm.bind(this);
        this.onCodeChange = this.onCodeChange.bind(this);
        this.onDescriptionChange = this.onDescriptionChange.bind(this);
        this.onDiscountChange = this.onDiscountChange.bind(this);
        this.onStartDateChange = this.onStartDateChange.bind(this);
        this.onEndDateChange = this.onEndDateChange.bind(this);
    }

    delete() {
        if (confirm("Are you sure you want to delete this promo?")) {
            this.props.delete(this.state.promo.id);
        }
    }

    onSave(err) {
        this.setState({ formError: err });
    }

    saveForm(e) {
        e.preventDefault();
        this.props.save(this.state.promo, this.onSave);
    }

    onCodeChange(e) {
        this.setState(
            Deeply(this.state)
                .set("promo.code", e.target.value)
                .value()
        );
    }

    onDescriptionChange(e) {
        this.setState(
            Deeply(this.state)
                .set("promo.description", e.target.value)
                .value()
        );
    }

    onDiscountChange(e) {
        this.setState(
            Deeply(this.state)
                .set("promo.discount", e.target.value)
                .value()
        );
    }

    onStartDateChange(e) {
        if (e.target.value) {
            this.setState(
                Deeply(this.state)
                    .set("promo.startDate", moment(e.target.value))
                    .value()
            );
        } else {
            this.setState(
                Deeply(this.state)
                    .set("promo.startDate", null)
                    .value()
            );
        }
    }

    onEndDateChange(e) {
        if (e.target.value) {
            this.setState(
                Deeply(this.state)
                    .set("promo.endDate", moment(e.target.value))
                    .value()
            );
        } else {
            this.setState(
                Deeply(this.state)
                    .set("promo.endDate", null)
                    .value()
            );
        }
    }

    render() {
        const p = this.state.promo;

        const startDate = p.startDate ? p.startDate.format("Y-MM-DD") : "";
        const endDate = p.endDate ? p.endDate.format("Y-MM-DD") : "";

        return (
            <Paper style={internals.paperStyle}>
                <form onSubmit={this.saveForm}>
                    <p style={{ color: "red" }}>{this.state.formError}</p>

                    <div className="form-group">
                        <TextField
                            floatingLabelText="Code"
                            value={p.code}
                            onChange={this.onCodeChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <TextField
                            floatingLabelText="Description"
                            value={p.description}
                            onChange={this.onDescriptionChange}
                        />
                    </div>
                    <div className="form-group">
                        <TextField
                            floatingLabelText="Discount"
                            value={p.discount}
                            onChange={this.onDiscountChange}
                            type="number"
                            min={0}
                            max={1}
                            step={0.01}
                        />
                    </div>
                    <div className="form-group">
                        <TextField
                            floatingLabelText="Start Date"
                            floatingLabelFixed={true}
                            value={startDate}
                            onChange={this.onStartDateChange}
                            type="date"
                        />
                    </div>
                    <div className="form-group">
                        <TextField
                            floatingLabelText="End Date"
                            floatingLabelFixed={true}
                            value={endDate}
                            onChange={this.onEndDateChange}
                            type="date"
                        />
                    </div>
                    <RaisedButton
                        primary
                        label="Save"
                        labelStyle={{
                            textTransform: "inherit"
                        }}
                        type="submit"
                        disabled={this.props.isSaving}
                    />

                    {this.props.showDelete && (
                        <RaisedButton
                            secondary
                            label="Delete"
                            onClick={this.delete}
                            labelStyle={{
                                textTransform: "inherit"
                            }}
                            disabled={this.props.isSaving}
                        />
                    )}
                </form>
            </Paper>
        );
    }
};



// WEBPACK FOOTER //
// ./src/routes/admin-promocodes/components/PromoCodeForm.js